import { useTranslation } from 'react-i18next'

import { Switch, Text } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import ReferenceDateSelector from '../ReferenceDateSelector/ReferenceDateSelector'
import AllowedExchangeMethodsSelector from './AllowedExchangeMethodsSelector/AllowedExchangeMethodsSelector'
import AllowedExchangeTypesSelector from './AllowedExchangeTypesSelector/AllowedExchangeTypesSelector'
import AllowEvenExchangesCatalogSwitch from './AllowEvenExchangesCatalogSwitch/AllowEvenExchangesCatalogSwitch'
import InstantExchangesConfiguration from './InstantExchangesConfiguration/InstantExchangesConfiguration'
import MaxDurationForExchanges from './MaxDurationForExchanges/MaxDurationForExchanges'
import NormalExchangesConfiguration from './NormalExchangesConfiguration/NormalExchangesConfiguration'
import * as Styles from './styles'

const ExchangesConfiguration = ({
  allowedPreferences,
  provider,
  configurationPreferences,
  allowExchanges,
  setAllowExchanges,
  maxDurationForExchanges,
  setMaxDurationForExchanges,
  allowedExchangeMethods,
  setAllowedExchangeMethods,
  exchangeOrdersAutomaticCreation,
  setExchangeOrdersAutomaticCreation,
  issueExchangeAtStatus,
  setIssueExchangeAtStatus,
  exchangeErrorResolution,
  setExchangeErrorResolution,
  exchangeOrdersSendProviderNotification,
  setExchangeOrdersSendProviderNotification,
  allowEvenExchangesCatalogPrice,
  setAllowEvenExchangesCatalogPrice,
  allowInstantExchanges,
  setAllowInstantExchanges,
  instantExchangeOrdersAutomaticCreation,
  setInstantExchangeOrdersAutomaticCreation,
  instantExchangeOrdersSendProviderNotification,
  setInstantExchangeOrdersSendProviderNotification,
  availableIssueExchangeStatus,
  allowsUnifiedFlow,
  subscriptionPlan,
  exchangeReferenceDate,
  onChangeExchangeReferenceDate,
  externalConnectedGateway,
  isUnifiedDashboard,
  disabled,
  allowsInstantTransactions,
  exchangePaymentExpiration,
  setExchangePaymentExpiration,
  instantExchangePaymentExpiration,
  setInstantExchangePaymentExpiration,
}) => {
  const { t } = useTranslation()

  if (
    !allowedPreferences.includes(preferences.allowsExchanges) &&
    !allowedPreferences.includes(preferences.allowsInstantExchanges)
  ) {
    return null
  }

  const handleDisableExchanges = checked => {
    setAllowExchanges(checked)
    setAllowInstantExchanges(checked)
  }

  return (
    <Styles.Container allowExchanges={allowExchanges}>
      <Switch
        label={<Text type="titleS">{t('Permitir cambios')}</Text>}
        checked={allowExchanges || allowInstantExchanges}
        onChange={e => handleDisableExchanges(e.target.checked)}
        disabled={disabled}
      />
      {(allowExchanges || allowInstantExchanges) && (
        <>
          <Text type="bodyMRegular">
            {t('Los clientes podrán solicitar cambios en el plazo definido a través del portal.')}
          </Text>
          <MaxDurationForExchanges
            maxDurationForExchanges={maxDurationForExchanges}
            setMaxDurationForExchanges={setMaxDurationForExchanges}
            disabled={disabled}
          />
          <ReferenceDateSelector
            referenceDate={exchangeReferenceDate}
            onChangeReferenceDate={onChangeExchangeReferenceDate}
            disabled={disabled}
          />
          <Styles.SubsectionContainer>
            <Text type="titleS">{t('Tipos de cambio')}</Text>
            <AllowedExchangeTypesSelector
              allowedPreferences={allowedPreferences}
              allowExchanges={allowExchanges}
              allowInstantExchanges={allowInstantExchanges}
              allowsUnifiedFlow={allowsUnifiedFlow}
              setAllowExchanges={setAllowExchanges}
              setAllowInstantExchanges={setAllowInstantExchanges}
              subscriptionPlan={subscriptionPlan}
              disabled={disabled}
              allowsInstantTransactions={allowsInstantTransactions}
            />
            <InstantExchangesConfiguration
              allowExchanges={allowExchanges}
              allowInstantExchanges={allowInstantExchanges}
              allowedPreferences={allowedPreferences}
              instantExchangeOrdersAutomaticCreation={instantExchangeOrdersAutomaticCreation}
              setInstantExchangeOrdersAutomaticCreation={setInstantExchangeOrdersAutomaticCreation}
              instantExchangeOrdersSendProviderNotification={instantExchangeOrdersSendProviderNotification}
              setInstantExchangeOrdersSendProviderNotification={setInstantExchangeOrdersSendProviderNotification}
              provider={provider}
              disabled={disabled}
              instantExchangePaymentExpiration={instantExchangePaymentExpiration}
              setInstantExchangePaymentExpiration={setInstantExchangePaymentExpiration}
            />
            <NormalExchangesConfiguration
              allowExchanges={allowExchanges}
              allowedExchangeMethods={allowedExchangeMethods}
              allowedPreferences={allowedPreferences}
              availableIssueExchangeStatus={availableIssueExchangeStatus}
              exchangeErrorResolution={exchangeErrorResolution}
              exchangeOrdersAutomaticCreation={exchangeOrdersAutomaticCreation}
              exchangeOrdersSendProviderNotification={exchangeOrdersSendProviderNotification}
              issueExchangeAtStatus={issueExchangeAtStatus}
              provider={provider}
              setExchangeErrorResolution={setExchangeErrorResolution}
              setExchangeOrdersAutomaticCreation={setExchangeOrdersAutomaticCreation}
              setExchangeOrdersSendProviderNotification={setExchangeOrdersSendProviderNotification}
              setIssueExchangeAtStatus={setIssueExchangeAtStatus}
              subscriptionPlan={subscriptionPlan}
              disabled={disabled}
              exchangePaymentExpiration={exchangePaymentExpiration}
              setExchangePaymentExpiration={setExchangePaymentExpiration}
            />
          </Styles.SubsectionContainer>
          {!isUnifiedDashboard && (
            <Styles.SubsectionContainer>
              <Text type="titleS">{t('Nuevos productos solicitados')}</Text>
              <AllowedExchangeMethodsSelector
                allowedPreferences={allowedPreferences}
                allowedExchangeMethods={allowedExchangeMethods}
                provider={provider}
                setAllowedExchangeMethods={setAllowedExchangeMethods}
                preferences={configurationPreferences}
                subscriptionPlan={subscriptionPlan}
                externalConnectedGateway={externalConnectedGateway}
                disabled={disabled}
              />
              <AllowEvenExchangesCatalogSwitch
                allowEvenExchangesCatalogPrice={allowEvenExchangesCatalogPrice}
                setAllowEvenExchangesCatalogPrice={setAllowEvenExchangesCatalogPrice}
                allowedExchangeMethods={allowedExchangeMethods}
                allowedPreferences={allowedPreferences}
                disabled={disabled}
              />
            </Styles.SubsectionContainer>
          )}
        </>
      )}
    </Styles.Container>
  )
}

export default ExchangesConfiguration
